import i18next from 'i18next';

i18next.addResources('es_CL', 'CancelOrderCreationModal', {
  processingOrder: 'Tu pedido se está generando',
  cancel: 'Cancelar',
  detail: 'Detalle',
  total: 'Total: {{total}}'
});
